import { render, staticRenderFns } from "./peiBuDetalis.vue?vue&type=template&id=64955c28&scoped=true&"
import script from "./peiBuDetalis.vue?vue&type=script&lang=js&"
export * from "./peiBuDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64955c28",
  null
  
)

export default component.exports